import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { faTrophy } from '@fortawesome/free-solid-svg-icons';
import { AuthorizeService } from 'src/api-authorization/authorize.service';
import { Player } from 'src/models/player.model';
import { UserService } from 'src/services/user.service';


@Component({
  selector: 'tournament',
  templateUrl: './tournament.component.html',
  styleUrls: ['./tournament.component.scss']
})
export class AdminTournamentComponent implements OnInit {
  public busy: boolean;
  public tournamentBrackets = [];
  public faTrophy = faTrophy;

  constructor(private http: HttpClient, private authorizeService: AuthorizeService, private router: Router) {
  }

  public ngOnInit() {
    this.busy = true;
    this.http.get<any>('/admin/getalltournament').subscribe(
      (resp) => {
        console.log(resp);
        for (let key of Object.keys(resp)) {
          if (resp[key] != null) {

            let tournamentBracket = {};
            tournamentBracket['round8'] = [];
            for (const n of resp[key].round8) {
              if (n.player)
                tournamentBracket['round8'].push({ player: new Player(n.player), score: n.score });
              else
                tournamentBracket['round8'].push({});
            }
            tournamentBracket['round4'] = [];
            for (const n of resp[key].round4) {
              if (n.player)
                tournamentBracket['round4'].push({ player: new Player(n.player), score: n.score });
              else
                tournamentBracket['round4'].push({});
            }
            tournamentBracket['round2'] = [];
            for (const n of resp[key].round2) {
              if (n.player)
                tournamentBracket['round2'].push({ player: new Player(n.player), score: n.score });
              else
                tournamentBracket['round2'].push({});
            }
            tournamentBracket['round1'] = [];
            for (const n of resp[key].round1) {
              if (n.player)
                tournamentBracket['round1'].push({ player: new Player(n.player), score: n.score });
              else
                tournamentBracket['round1'].push({});
            }
            this.tournamentBrackets.push(tournamentBracket);
          }
        }
      },
      (err) => alert(err)
    )

    this.busy = false;
  }



}
